// Common utils

// Gtags
export const triggerTagging = (eventName: string, page: string, value?: any) => {
  if (typeof window.gtag !== 'undefined') {
    if (value) {
      window.gtag('event', eventName, {
        page: page,
        value: value
      })
    }
    window.gtag('event', eventName, {
      page: page
    })
  }
}

// Remove Coupons
// Handle all special coupons here
export const shouldRemoveSpecialCoupons = (couponCode: string) => {
  if (couponCode && ['AADF', 'TRYME50', 'FREESAMPLE'].includes(couponCode)) {
    return true
  }
  return false
}
